import { trace } from 'rytm-helpers'
import { store } from './../store'

export const PAUSE_VIDEO_MAIN  = 'PAUSE_VIDEO_MAIN'
export const RESUME_VIDEO_MAIN  = 'RESUME_VIDEO_MAIN'
export const VIDEO_PLAYBACK_START  = 'VIDEO_PLAYBACK_START'
export const VIDEO_PLAYBACK_STOP  = 'VIDEO_PLAYBACK_STOP'


export const pauseVideoMain = () => {
  store.dispatch({type: PAUSE_VIDEO_MAIN})
}
export const resumeVideoMain = () => {
  store.dispatch({type: RESUME_VIDEO_MAIN})
}
export const videoPlaybackStart = () => {
  trace("video playback start")
  store.dispatch({type: VIDEO_PLAYBACK_START})
}
export const videoPlaybackStop = () => {
  store.dispatch({type: VIDEO_PLAYBACK_STOP})
}
